<script>
	import { navigate } from "svelte-routing";
	import { imageLightbox } from "../../../../../store/store";
	import { Table } from "sveltestrap";
	import CustomPaginate from "../../../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../../../components/Loader/LoaderContainer.svelte";
	import { FontAwesomeIcon } from "fontawesome-svelte";
	import { library } from "@fortawesome/fontawesome-svg-core";
	import { faPaperclip as fasPaperclip } from "@fortawesome/free-solid-svg-icons";
	import { convert } from "../../../../../services/helpers";
	export let data;
	library.add(fasPaperclip);

	//lightbox with image
	import Lightbox from "../../../../../components/Lightbox/Lightbox.svelte";

	let modalOpen = false;
	let imageShowingIndex = 0;

	const handleImgClick = (i) => {
		imageLightbox.set(i);
		imageShowingIndex = 0;
		modalOpen = true;
	};
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
{/if}

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Vehicle No.</th>
				<th>Damage Area</th>
				<th>Damage Type</th>
				<th>Report Section</th>
				<th>Photos/Videos</th>
				<th>Date Reported</th>
				<th>Source</th>
				<th>Status</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { vehicleId, reportSection, vehicleNumber, carSection, damageType, imageUrls, status, createdAt, originType }}
				<tr>
					<td>
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<p
							class="link"
							on:click={() =>
								navigate(
									`/car-management/details/${vehicleId}`
								)}
						>
							<span class="link-text">
								{vehicleNumber}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span>
								{carSection}
							</span>
						</p>
					</td>
					<td>
						{damageType ? damageType : "NA"}
					</td>
					<td>
						{reportSection}
					</td>
					<td>
						<h4 class="">
							&nbsp;&nbsp;
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<!-- svelte-ignore a11y-interactive-supports-focus -->
							<i
								role="button"
								on:click={() => handleImgClick(imageUrls)}
							>
								<FontAwesomeIcon icon={fasPaperclip} />
							</i>
						</h4>
					</td>

					<td>
						{convert(createdAt)}
					</td>
					<td>
						{#if originType === 0}
							FMS
						{:else if originType === 1}
							CMS
						{/if}
					</td>
					<td>
						{#if status === 0}
							<p class="status-bar status-bar-2">
								Pending Review
							</p>
						{:else if status === 1}
							<p class="status-bar status-bar-3">Rejected</p>
						{:else if status === 2}
							<p class="status-bar btn-primary">Accepted</p>
						{:else if status === 3}
							<p class="status-bar status-bar-1">Approved</p>
						{/if}
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.length === 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.length} />
</LoaderContainer>
